import { fmtChips } from "../../lib/api";

const BOARD = { TOP: "Top", BOTTOM: "Bottom", HIGH: "Hi", LOW: "Lo" };
const BELOW_SEAT_PX = 66; // pills hang just under the winner's name plate: the shown cards lift up towards the board, so nothing is covered

// Hand result as small pills beside each winner, one pill per pot (a bomb-pot board is its own pot). While the table
// presents the pots in turn, the pills for the pot on show are lit and the rest dim.
export const WinnerPills = ({ result, seats, current = null, slotFor, scale = 1 }) => {
  if (!result) return null;
  const name = (i) => seats[i]?.name || result.players.find((p) => p.seat === i)?.name || `Seat ${i + 1}`;
  const sidePots = new Set(result.awards.map((a) => a.pot ?? 0)).size > 1;
  const bySeat = {};
  result.awards.forEach((a, i) => a.winners.forEach((w) => (bySeat[w] = [...(bySeat[w] || []), { a, i }])));
  return Object.entries(bySeat).map(([seat, list]) => {
    const [x, y] = slotFor(Number(seat));
    return (
      <div key={seat} data-testid={`winner-pills-${seat}`} className="absolute z-30 flex flex-col items-center gap-1 pointer-events-none"
        style={{ left: `${x}%`, top: `calc(${y}% + ${Math.round(BELOW_SEAT_PX * scale)}px)`, transform: "translateX(-50%)" }}>
        {list.map(({ a, i }) => {
          const share = Math.floor(a.amount / a.winners.length);
          const tag = [sidePots ? ((a.pot ?? 0) === 0 ? "Main" : `SP${a.pot}`) : null, a.board ? BOARD[a.board] : null].filter(Boolean).join(" · ");
          return (
            <div key={i} data-testid={`result-award-${i}`}
              className={`glass rise rounded-full border border-amber-400/40 px-2.5 py-0.5 flex items-center gap-1.5 whitespace-nowrap text-[11px] leading-tight transition-opacity duration-300 ${current && !current.includes(a) ? "opacity-35" : ""}`}>
              {tag && <span data-testid={`result-award-${i}-tag`} className="text-[9px] uppercase tracking-[0.15em] text-amber-200/70">{tag}</span>}
              {a.winners.length > 1 && <span data-testid={`result-award-${i}-split`} className="text-slate-100 font-medium">{name(Number(seat))} <span className="text-[9px] uppercase tracking-[0.15em] text-sky-300">split {a.winners.length} ways</span></span>}
              <span className="font-mono text-amber-300" data-testid={`result-award-${i}-amount`}>+{fmtChips(share)}</span>
              {a.category && <span className="text-emerald-300 max-w-[11rem] truncate" data-testid={`result-award-${i}-hand`}>{a.category}</span>}
            </div>
          );
        })}
      </div>
    );
  });
};
